import { Component, OnInit, ViewChild } from '@angular/core';

import { Customer } from './../model/customer.model';

import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';

import { MatTableDataSource } from '@angular/material/table';

import { MatSnackBar } from '@angular/material/snack-bar';



import { ApiService } from './../../app/services/api.service'

import { MatDialog } from '@angular/material/dialog';

import { CustomerDialog } from './../../app/dialogs/customer/customer.component';

import { BilldetailsDialog } from './../../app/dialogs/billdetails/billdetails.component';

import { ImagepreviewComponent } from './../../app/dialogs/imagepreview/imagepreview.component';

import { QrcodeComponent } from '../dialogs/qrcode/qrcode.component';

import { AreaData } from '../model/area.model';

import { merge, Observable, of as observableOf, pipe } from 'rxjs';

import { catchError, map, startWith, switchMap } from 'rxjs/operators';

import { AddcomplaintComponent } from '../dialogs/addcomplaint/addcomplaint.component';

import { ViewcomplaintsComponent } from '../dialogs/viewcomplaints/viewcomplaints.component';

import { Complaint } from '../model/complaint';

import { Role } from '../model/role';

import { AreaFilterService } from '../services/area-filter.service';



@Component({

  selector: 'app-complaint',

  templateUrl: './complaint.component.html',

  styleUrls: ['./complaint.component.scss']

})

export class ComplaintComponent implements OnInit {



  displayedColumns: string[] = ['customerId', 'customerName', 'customerPhone', 'areaName', 'customerAddress', 'actions'];

  optionList = [

    { key: 1, name: 'Customer Id' },

    { key: 2, name: 'Customer Name' },

    { key: 3, name: 'Area Name' },

    { key: 4, name: 'Address' },

    { key: 5, name: 'Phone Number' }

  ];

  enableButton = false;

  isLoading = false;

  searchValue = '';

  totalData: number;

  selectedOption = 0;

  pageSizes = [15, 30, 50];

  searchTriggered = false;

  dataSource = new MatTableDataSource<Customer>(null);

  customer: Customer = {

    areaCode: null,

    areaName: null,

    meterId: 0,

    previousReading: 0,

    currentReading: 0,

    latitude: null,

    longitude: null,

    customerId: 0,

    customerName: '',

    customerPhone: null,

    customerPhone2: null,

    customerPhone3: null,

    customerEmail: '',

    customerAddress: '',

    customerStatus: '',

    customerJoinedDate: '',

    customerUnitRate: 0,

    defaultUnitRate: 0,

    customerDueAmount: 0,

    customerAction: 'add'

  }

  selectedCustomer: Customer;

  complaintData:Complaint[] = [];

  areas: AreaData[];

  @ViewChild('paginator') paginator: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(public dialog: MatDialog, private apiService: ApiService, private _snackBar: MatSnackBar, private areaFilterService: AreaFilterService) {



   

  }

  customers: Customer[] = [];



  ngOnInit(): void {

    this.checkLoginType();

  }



  openCusUpdateDialog(customerData: Customer): void {

    customerData.customerAction = 'add_complaint';

    const dialogRef = this.dialog.open(AddcomplaintComponent, {

      width: '900px',

      data: customerData

    });



    dialogRef.afterClosed().subscribe(result => {

    });

  }





  applyFilter(filterValue: string) {

    this.dataSource.filter = filterValue.trim().toLowerCase();

  }





  ngAfterViewInit() {

    this.isLoading = true;

    this.apiService.getCustomers(

      0,

      15,

      this.selectedOption,

      this.searchValue

    )

      .subscribe(empData => {

        this.totalData = empData.totalItems;

        this.dataSource = new MatTableDataSource<Customer>(this.areaFilterService.filterCustomersByArea(empData.customers));

        this.isLoading = false;

      });



      //this.getComplaintsData();



  }





  validateSearch() {

    if (this.searchValue.trim() != '' && this.selectedOption != 1 && this.selectedOption != 0 && this.searchValue.trim().length > 2) {

      this.enableButton = true;

    }

    else if (this.searchValue.trim() != '' && this.selectedOption == 1 && this.searchValue.trim().length > 0) {

      this.enableButton = true;

    } else {

      this.enableButton = false;

    }

  }

  getCustomerData() {

    this.isLoading = true;

    this.searchTriggered = true;

    this.apiService.getCustomers(

      0,

      15,

      this.selectedOption,

      this.searchValue

    )

      .subscribe(empData => {

        this.totalData = empData.totalItems;

        this.dataSource = new MatTableDataSource<Customer>(this.areaFilterService.filterCustomersByArea(empData.customers));

        this.isLoading = false;

      });



  }



  viewComplaintsDialog(){



    const dialogRef = this.dialog.open(ViewcomplaintsComponent, {

      width: '1400px',

      maxWidth:'100%'

    });



    dialogRef.afterClosed().subscribe((result) => {

    });



  }



  checkLoginType() {

    const loggedInUser = window.localStorage.getItem('loggedInUser');

    this.apiService.getEmplyeeDetailsById(loggedInUser).subscribe((data) => {

      

       let roles = data.roles.map((role : Role)=>role.roleName);

       if(roles.includes("sysadmin")){

         console.log("Sys Admin");

         

       }else{

        console.log("Not Sys Admin");

        

       }

       

    });

  }





  nextpage(event: PageEvent) {

    this.isLoading = true;

    if (this.searchTriggered) { event.pageIndex = 1; event.previousPageIndex = 0 };

    this.apiService.getCustomers(

      event.pageIndex,

      event.pageSize,

      this.selectedOption,

      this.searchValue

    )

      .subscribe(empData => {

        this.totalData = empData.totalItems;

        this.dataSource = new MatTableDataSource<Customer>(empData.customers);

        this.isLoading = false;

        this.searchTriggered = false;

      });



  }





  getComplaintsData(){

    this.apiService.getComplaints(0, 50000, '')

      .subscribe(data => {

        if(data && data.content){

          this.complaintData = data.content;

        }

        this.isLoading=false;

    });

}



}

